import Vue from "vue";
import VueRouter from "vue-router";

import store from "../store";
import smartComponentsLoader from "../views/view-router/smartComponentsLoader";

const Home = () => import("../views/Home.vue");
const Test = () => import("../views/Test.vue");
const History = () => import("../views/History.vue");
const BarConfigurator = () => import("../views/BarConfigurator.vue");
const Privacy = () => import("../views/Privacy.vue");
const About = () => import("../views/About.vue");
const Cocktails = () => import("../views/Cocktails.vue");
const Contact = () => import("../views/Contact.vue");
const News = () => import("../views/News.vue");

const NewsInner = () => import("../views/NewsInner.vue");
const Shop = () => import("../views/Shop.vue");
const ShopInner = () => import("../views/ShopInner.vue");
const UserPage = () => import("../views/UserPage.vue");
const Cart = () => import("../views/Cart.vue");
// const CartStep1 = () => import("../views/CartStep1.vue");



Vue.use(VueRouter);

const routes = [
  {
    path:
      "/en/:path1?/:path2?/:path3?/:path4?/:path5?/:path6?/:path7?/:path8?/:path9?/",
    name: "en",
    meta: { bodyClass: "page" },
    component: smartComponentsLoader,
    props: true
  },

  {
    path:
      "/ge/:path1?/:path2?/:path3?/:path4?/:path5?/:path6?/:path7?/:path8?/:path9?/",
    name: "ge",
    meta: { bodyClass: "page" },
    component: smartComponentsLoader,
    props: true
  },

  {
    path: '/',
    name: 'ge',
    component: smartComponentsLoader,
   
  },
  // {
  //   path: "/test",
  //   name: "test",
  //   meta: { bodyClass: "page" },
  //   component: Test,
  //   props: true
  // },
  // {
  //   path: "/history",
  //   name: "history",
  //   meta: { bodyClass: "page" },
  //   component: History,
  //   props: true
  // },
  // {
  //   path: "/bar",
  //   name: "bar",
  //   meta: { bodyClass: "page" },
  //   component: BarConfigurator,
  //   props: true
  // },
  // {
  //   path: "/privacy",
  //   name: "privacy",
  //   meta: { bodyClass: "page" },
  //   component: Privacy,
  //   props: true
  // },
  // {
  //   path: "/about",
  //   name: "about",
  //   meta: { bodyClass: "page" },
  //   component: About,
  //   props: true
  // },
  {
    path: "/cocktails",
    name: "cocktails",
    meta: { bodyClass: "page" },
    component: Cocktails,
    props: true
  },
  // {
  //   path: "/contact",
  //   name: "contact",
  //   meta: { bodyClass: "page" },
  //   component: Contact,
  //   props: true
  // },
  // {
  //   path: "/news",
  //   name: "news",
  //   meta: { bodyClass: "page" },
  //   component: News,
  //   props: true
  // },
  // {
  //   path: "/cart",
  //   name: "cart",
  //   meta: { bodyClass: "page" },
  //   component: Cart,
  //   props: true
  // },
  // {
  //   path: "/cartstep1",
  //   name: "cartstep1",
  //   meta: { bodyClass: "page" },
  //   component: CartStep1,
  //   props: true
  // },
  // {
  //   path: "/news-inner",
  //   name: "news-inner",
  //   meta: { bodyClass: "page" },
  //   component: NewsInner,
  //   props: true
  // },
  // {
  //   path: "/shop",
  //   name: "shop",
  //   meta: { bodyClass: "page" },
  //   component: Shop,
  //   props: true
  // },
  // {
  //   path: "/shop-inner",
  //   name: "shop-inner",
  //   meta: { bodyClass: "page" },
  //   component: ShopInner,
  //   props: true
  // },
  // {
  //   path: "/user",
  //   name: "user",
  //   meta: { bodyClass: "page" },
  //   component: UserPage,
  //   props: true
  // },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  store,
  scrollBehavior(to, from, savedPosition) {
    // store.commit('setState', {key: 'offset', val: 0});
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 0 }
      };
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;
